import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {BlacklistItem, BlacklistsState} from './types';
import {directDownloadLK} from "@/utils/download-helper";

export const actions: ActionTree<BlacklistsState, RootState> = {
    getBlacklists: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            axios({url: '/lk-api/black-list', params: data})
                .then(resp => {
                    commit('setBlacklists', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    getBlackListItem: ({commit, dispatch}, id: number) => {
        return new Promise((resolve, reject) => {
            axios({url: `/lk-api/black-list?blackListId=${id}`})
                .then((resp: any) => {
                    let blacklistItem = <BlacklistItem>resp.data;
                    blacklistItem.id = id;
                    commit('setBlackListItem', blacklistItem);
                    resolve(blacklistItem)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    saveBlackList: ({commit, dispatch}, data: BlacklistItem) => {
        return new Promise((resolve, reject) => {
            axios({
                method: data.blackListId ? 'put' : 'post',
                url: '/lk-api/black-list',
                data: data
            })
                .then((resp: any) => {
                    console.log(resp.data);
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    deleteBlackList: ({commit, dispatch}, data: BlacklistItem) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: '/lk-api/black-list/',
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    exportBlackListContacts: ({commit, dispatch}, blacklistId: number) => {
        directDownloadLK(`/lk-api/black-list/address-book-contact/export?listId=${blacklistId}`)
    },
    importBlackListContacts: ({commit, dispatch}, data: any) => {
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/black-list/address-book-contact/import`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp?.data)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    getBlackListContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({url: `/lk-api/black-list/address-book-contact`, params: data })
                .then((resp: any) => {
                    if (data.page_number > 1) {
                        commit('setBlacklistContactsMore', resp.data.contacts);
                    } else {
                        commit('setBlacklistContacts', resp.data.contacts);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    saveBlackListContact: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: `/lk-api/black-list/address-book-contact`,
                data: data
            })
                .then((resp: any) => {
                    console.log(resp.data);
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    deleteBlackListContact: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/lk-api/black-list/address-book-contact`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    copyBlackListContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/black-list/address-book-contact/copy`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    moveBlackListContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/black-list/address-book-contact/move`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
};
